import { ProductCategory } from "@/types/product";

const STORAGE_KEY = 'product_categories';

type CategoryUpdateCallback = (categories: any[]) => void;
const subscribers = new Set<CategoryUpdateCallback>();

export function getStoredCategories(): ProductCategory[] {
  const categories = localStorage.getItem(STORAGE_KEY);
  if (!categories) {
    // Initialize with default categories
    const defaultCategories = [
      { id: 'equipment', name: 'Equipment', createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() },
      { id: 'supplies', name: 'Supplies', createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() },
      { id: 'food-beverage', name: 'Food & Beverage', createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() },
      { id: 'decorations', name: 'Decorations', createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() },
      { id: 'other', name: 'Other', createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() },
    ];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultCategories));
    return defaultCategories;
  }
  return JSON.parse(categories);
}

export function addStoredCategory(category: unknown) {
  const categories = getStoredCategories();
  categories.push(category as ProductCategory);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(categories));
  notifySubscribers(categories);
  return category;
}

export function updateStoredCategory(category: any) {
  const categories = getStoredCategories();
  const index = categories.findIndex((c: any) => c.id === category.id);
  if (index !== -1) {
    categories[index] = category;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(categories));
    notifySubscribers(categories);
  }
  return category;
}

export function deleteStoredCategory(categoryId: string) {
  const categories = getStoredCategories();
  const filteredCategories = categories.filter((c: any) => c.id !== categoryId);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredCategories));
  notifySubscribers(filteredCategories);
}

function notifySubscribers(categories: unknown[]) {
  subscribers.forEach(callback => callback(categories));
}

export function subscribeToCategoryUpdates(callback: CategoryUpdateCallback) {
  subscribers.add(callback);
  return () => {
    subscribers.delete(callback);
  };
}